/**
 * What today does once a FAIL takes the list out (user, 23/10/2026: "list
 * come back action when list verdict fail must be hidden … replace it by
 * stop list or complete list"): Stop list skips the rest of its day,
 * Complete list lets today finish. The "A list fails" card, moved under the
 * FAIL chip — still its own inheritable field (section failMode), its
 * source beside it.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import { XOctagon } from 'lucide-react';

import { FailModeChoice } from '../../general/fields/FailModeField';
import { InheritTag } from '../../master/InheritTag';
import type { ContainerEditor } from '../../state/useContainerEditor';
import { ConsequenceRow } from './ConsequenceRow';
import { failModeNote, failModeWord, HINTS } from './fail-words';

export const FailModeRow: FC<{ editor: ContainerEditor }> = ({ editor }) => {
  const { failMode } = editor.draft;
  return (
    <ConsequenceRow icon={XOctagon} label="A list fails" hint={HINTS.failMode} testId="fail-mode">
      <FailModeChoice value={failMode} onChange={(value) => editor.setField('failMode', value)} compact />
      <span className="text-muted-foreground">{failModeNote(failMode)}</span>
      <span className="ml-auto">
        <InheritTag section="failMode" masterValue={(m) => failModeWord(m.failMode)} />
      </span>
    </ConsequenceRow>
  );
};
